module.exports = __webpack_public_path__ + "img/men1.ba1eccf1.jpg";